<script setup lang="ts">
import { Button } from '@/components/ui/button';

const props = defineProps<{
    onClick: () => void;
    disabled?: boolean;
}>();

const handleClick = () => {
    if (!props.disabled) {
        props.onClick();
    }
};
</script>

<template>
    <Button @click="handleClick" class="relative flex h-14 w-full items-center rounded-[4px] bg-[#393734] hover:bg-[#393734] active:bg-[#393734] hover:opacity-100 active:opacity-100 text-white">
        <span class="text-lg font-semibold leading-6"><slot /></span>
        <svg class="absolute right-5 top-5 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
        </svg>
    </Button>
</template>
